import { BaseService } from "core/services";
import { DocumentTypeRouteService } from "application/tracking-case/services";

class DocumentTypeService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new DocumentTypeRouteService());
    }
}

export default DocumentTypeService;